import React from 'react'
import TextGeneratorComponent from '../../components/Analysis/TextGenerator'

const TextGeneratorPage = () => {
  return (
    <TextGeneratorComponent />
  )
}

export default TextGeneratorPage